import React from 'react';
import AddThresholdForm from './addThresholdForm';


export default function AddThreshold(){


    return(
        <div className="myPetitionPage myThresholdPage">
            <AddThresholdForm />
        </div>
    )
}